// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__Ke3en","succesfulText":"ResetPassword_succesfulText__R9ehD"};